/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExecutionProfileServer,
  ExecutionProfileServer$inboundSchema,
} from "./executionprofileserver.js";

/**
 * Whether the turns act for the user their event identified.
 */
export const ExecutionContext = {
  UserBacked: "user_backed",
  Userless: "userless",
} as const;
/**
 * Whether the turns act for the user their event identified.
 */
export type ExecutionContext = OpenEnum<typeof ExecutionContext>;

/**
 * The upstream credentials an assistant's turns under one root trigger and execution context use.
 */
export type AssistantExecutionProfile = {
  /**
   * Whether the turns act for the user their event identified.
   */
  executionContext: ExecutionContext;
  /**
   * Each server the turns reach.
   */
  servers: Array<ExecutionProfileServer>;
  /**
   * The root trigger.
   */
  triggerInstanceId: string;
  /**
   * The root trigger's name.
   */
  triggerName: string;
  /**
   * The latest version; 0 before the first turn or change.
   */
  version: number;
};

/** @internal */
export const ExecutionContext$inboundSchema: z.ZodMiniType<
  ExecutionContext,
  unknown
> = openEnums.inboundSchema(ExecutionContext);

/** @internal */
export const AssistantExecutionProfile$inboundSchema: z.ZodMiniType<
  AssistantExecutionProfile,
  unknown
> = z.pipe(
  z.object({
    execution_context: ExecutionContext$inboundSchema,
    servers: z.array(ExecutionProfileServer$inboundSchema),
    trigger_instance_id: z.string(),
    trigger_name: z.string(),
    version: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "execution_context": "executionContext",
      "trigger_instance_id": "triggerInstanceId",
      "trigger_name": "triggerName",
    });
  }),
);

export function assistantExecutionProfileFromJSON(
  jsonString: string,
): SafeParseResult<AssistantExecutionProfile, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantExecutionProfile$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantExecutionProfile' from JSON`,
  );
}
